var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1C1B1A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1501.249 30c-1.864 0-3.392 1.523-3.392 3.387v1.997h-3.552c-.383.037-.684.344-.715.727l-1.587 18.429c-.019.22.056.44.206.603.15.164.362.257.584.257h19.5c.222 0 .435-.093.585-.256.15-.164.226-.383.207-.604l-1.589-18.429c-.034-.41-.378-.727-.79-.727h-3.475v-1.997c0-1.864-1.523-3.387-3.387-3.387h-2.595zm0 1.587h2.595c1.012 0 1.8.788 1.8 1.8v1.997h-6.2v-1.997c0-1.012.793-1.8 1.805-1.8zm-6.141 5.386h2.749v2.355c.01.432.362.777.793.777.432 0 .785-.345.794-.777v-2.355h6.2v2.355c.01.432.362.776.794.776.431 0 .784-.344.793-.776v-2.355h2.749l1.446 16.84h-17.764l1.446-16.84z",
    transform: "translate(-1492.000000, -30.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.13aa4c019a219dcc97ee91ce5ec92af4.svg";
export { ForwardRef as ReactComponent };